let anchor = document.createElement("a");

let _File = {
  download(name, type, text) {
    let blob = new Blob([text], { type });
    let url = URL.createObjectURL(blob);

    if (navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, name);
    }
    else {
      document.body.appendChild(anchor);

      anchor.href = url;
      anchor.download = name;
      anchor.click();

      document.body.removeChild(anchor);
    }

    URL.revokeObjectURL(url);

    return blob.size;
  }
};

module.exports = _File;
